/* Reconstructed from tenant.zip:public/build/assets/array-FrBPf9mT.js
 * Original SHA-256: 4819327bfea099906e92ee0311e5508bb29e800bdb108228586c8761bac5e9d3
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
function e(e, t) {
  if (!t || _.isEmpty(t)) return e;
  Object.keys(t).forEach((e) => {
    (t[e] === `` || t[e] == null) && delete t[e];
  });
  let n = Object.keys(t)
    .map((e) => _.snakeCase(e) + `=` + t[e])
    .join(`&`);
  return n ? e + (e.includes(`?`) ? `&` : `?`) + n : e;
}
export { e as t };
